/** Textos exibidos nos toasts da página Meus Anúncios — sempre em PT-BR. */
const MY_ADS_TOAST = {
	SUCCESS: {
		AD_UPDATED: 'Anúncio atualizado com sucesso',
		AD_REACTIVATED: 'Anúncio reativado com sucesso',
		AD_DEACTIVATED: 'O anúncio foi desativado com sucesso',
		AD_MARKED_SOLD: 'Anúncio marcado como vendido',
		AD_DELETED: 'Anúncio excluído com sucesso',
		PLAN_UPDATED: 'Plano atualizado com sucesso!'
	},
	ERROR: {
		SAVE_CHANGES: 'Não foi possível salvar as alterações. Tente novamente.',
		REACTIVATE: 'Não foi possível reativar o anúncio. Tente novamente.',
		DEACTIVATE: 'Não foi possível desativar o anúncio. Tente novamente.',
		MARK_SOLD: 'Não foi possível marcar o anúncio como vendido. Tente novamente.',
		DELETE: 'Não foi possível excluir o anúncio. Tente novamente.',
		RESUME_INCOMPLETE: 'Não foi possível retomar o anúncio. Tente novamente em instantes.',
		PAYMENT_CHECKOUT: 'Não foi possível abrir o pagamento do anúncio. Tente novamente em instantes.',
		PHOTO_PROCESS: 'Não foi possível processar a foto. Tente novamente.',
		KILOMETERS_MIN: 'A quilometragem deve ser superior a 100 km.'
	}
} as const;

export { MY_ADS_TOAST };
